import SelectEventType from '.';
const SelectEventTypeRoutes = [
    {
        name: '/select-event-type',
        deepLink: '/select-event-type',
        component: SelectEventType,
    },
];
export default SelectEventTypeRoutes;
